import React, { Fragment, useMemo, useState } from 'react';
import { LoadingSpinner } from '../../../../constants/AppLoading';
import AppTable from '../../../../constants/AppTable';
import { GeneralLedger } from '../../../../helpers/models/Models';
import { StatusBadge } from '../../../../constants/AppBadge';
import GLedgerEditView from './GLedgerEditView';
interface GeneralLedgerListViewProps {
  data: {
    data: GeneralLedger[];
    previous: string | null;
    next: string | null;
  } | null;
  loading: boolean;
  error: string | null;
  handleFormSuccess: ()=>void;
}

const GLedgerListView: React.FC<GeneralLedgerListViewProps> = ({ data, handleFormSuccess, loading, error }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState<GeneralLedger | null>(null);
  const columns = [
    { header: 'GLID', accessor: 'glid', sortable: true },
    { header: 'GL Name', accessor: 'gl_name', sortable: true },
    { header: 'GL Name(nepali)', accessor: 'gl_name_nep', sortable: false },
    { header: 'GL Type', accessor: 'gl_typee', sortable: false },
    { header: 'Actual GLID', accessor: 'actual_glid', sortable: false },
    { header: 'Details RPT Mode', accessor: 'rpt_det_mod', sortable: false },
    { header: 'Actions', accessor: 'actions', action: true },
  ];

  const modifiedData = useMemo(() => {
    if (!data) return [];
    return data.data.map((item: GeneralLedger) => ({
      ...item,
      glid: item.glid,
      gl_name: item.gl_name,
      gl_name_nep: item.gl_name_nep,
      active: item.gl_status,
      gl_type: item.gl_type,
      gl_typee: item.gl_type === 1 ? "Assets" : item.gl_type === 2 ? "Liabilities" : item.gl_type === 3 ? "Income" : "Expenses",
      actual_glid: item.actual_glid,
      rpt_det_mode: item.rpt_det_mode,
      rpt_det_mod: <StatusBadge status={item.rpt_det_mode} />,
      actions: (
        <button onClick={() => handleEdit(item)}>Edit</button>
      ),
    }));
  }, [data]);

  const handleEdit = (item: GeneralLedger) => {
    setCurrentItem(item);
    setDialogOpen(true);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return <p>Error loading data: {error}</p>;
  }

  return (
    <Fragment>
      <AppTable
        columns={columns}
        data={modifiedData}
        onEdit={handleEdit}
      />
      <GLedgerEditView dialogOpen={dialogOpen} handleFormSuccess={handleFormSuccess} setDialogOpen={setDialogOpen} currentItem={currentItem} />
    </Fragment>
  );
};

export default GLedgerListView;
